export const convertGidToId = (shopifyGid: string) =>
  shopifyGid
    .replace('gid://shopify/Product/', '')
    .replace('gid://shopify/ProductVariant/', '')
